import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import HighLowAverageMobile from '@Components/DataAnalysis/HighLowAverageMobile';
import ValueInsightPortalBanner from '@Components/Shared/ValueInsightPortalBanner';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import ComplexBreadcrumb from '@Components/Shared/ComplexBreadcrumb';
import { useEffect, useState } from 'react';
import { gtmPushEvent } from '@Components/Utilities/SandhillsUtility';
import { gtmEventType } from '@Components/Utilities/SandhillsConstants';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const HighLowAverageView = (props) => {

    const [showReasons, setShowReasons] = useState(false);
    const windowSize = useWindowSize();
    const currentSite = useRecoilValue(atoms.currentWebsite);
    useEffect(() => { gtmPushEvent(gtmEventType.highLowAvg) }, []);


    return (
        <div>
            {windowSize.isMobile ?
                <HighLowAverageMobile {...props} />
                :
                <div id='high-low-average-content'>
                    <section id='high-low-average-top'>
                        <div>
                            <ComplexBreadcrumb BreadCrumbModels={props.Breadcrumbs} />
                            {props.RegionFilterURL &&
                                <div id='region-filter'>
                                    <a href={props.RegionFilterURL}>{props.RegionFilterLinkText}</a>
                                </div>
                            }
                            <h1 id='high-low-title'><TranslationText tKey='sandhills.tradepubwebsite.mvc.hilowaverage' /></h1>
                            {!currentSite.IsMobileAppContext &&
                                <a href={props.AllListingsPageURL} id='return-to-listings-link'>
                                    <i className='fas fa-arrow-left' />&nbsp;
                                    <TranslationText tKey='sandhills.returntolistings' />
                                </a>
                            }
                        </div>
                    </section>
                    <section id='search-criteria'>
                        {(props.Criteria && Object.keys(props.Criteria).length > 0) && Object.keys(props.Criteria).map(key =>
                            <div key={key} className='criteria'>
                                <b>{key}:</b>&nbsp;{props.Criteria[key]}
                            </div>)}
                    </section>
                    {!props.ShowAV &&
                        <ValueInsightPortalBanner />
                    }
                    <table id='high-low-average-table'>
                        <colgroup>
                            <col />
                            <col />
                            <col />
                        </colgroup>
                        <thead>
                            <tr>
                                <td id='description-column'></td>
                                {props.UseAverageTitle
                                    ? <th><TranslationText tKey='Sandhills.TradeSites.MVC.averageplaceholderprice' replaceValues={[props.RetailTitle]} /></th>
                                    : <th>{props.RetailTitle} <TranslationText tKey='sandhills.tradepubwebsite.mvc.hilowaverage' /></th>}

                                {props.ShowAuctionHighLowAverage &&
                                    (props.UseAverageTitle
                                    ? <th><TranslationText tKey='Sandhills.TradeSites.MVC.averageplaceholderprice' replaceValues={[translator.translate('sandhills.tradepubwebsite.mvc.onauctiontext')]} /></th>
                                    : <th><TranslationText tKey='sandhills.tradepubwebsite.mvc.auction' /> <TranslationText tKey='sandhills.tradepubwebsite.mvc.hilowaverage' /></th>)}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.totalnumberoflistingsfound' /></td>
                                <td>{props.DisableRetailLink ? <>{props.Retail.Count}</> : <a id='hi-lo-avg-retail-link' href={props.ListingPageURL} target={props.OpenRetailLinkInNewTab ? '_blank' : '_self'} aria-label={props.OpenRetailLinkInNewTab ? props.Retail.Count + " (" + translator.translate('sandhills.opensinanewtab') + ")" : props.Retail.Count}>{props.Retail.Count}</a>}</td>
                                {props.ShowAuctionHighLowAverage &&
                                    <td><a id='hi-lo-avg-auction-link' href={props.AuctionPageURL}>{props.Auction.Count}</a></td>}
                            </tr>
                            <tr>
                                <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.highestpricefound' /></td>
                                <td>{props.Retail.MaximumPrice}</td>
                                {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.MaximumPrice}</td>}
                            </tr>
                            <tr>
                                <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.lowestpricefound' /></td>
                                <td>{props.Retail.MinimumPrice}</td>
                                {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.MinimumPrice}</td>}
                            </tr>
                            <tr className='bold'>
                                <td><TranslationText tKey='sandhills.tradepubwebsite.mvc.averageprice' /></td>
                                <td>{props.Retail.AveragePrice}</td>
                                {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.AveragePrice}</td>}
                            </tr>
                            <tr className='bold'>
                                <td><TranslationText tKey='sandhills.avgwohighlow' /></td>
                                <td>{props.Retail.AdjustedAveragePrice}</td>
                                {props.ShowAuctionHighLowAverage &&
                                    <td>{props.Auction.AdjustedAveragePrice}</td>}
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    <br />
                    <section id='bottom-description' dangerouslySetInnerHTML={{ __html: props.Explanation }} />
                    {props.NoLinkReason &&
                        <>
                        <br />
                        <button className='ts-button' id='show-reasons-button' onClick={() => setShowReasons(!showReasons)}>
                            {showReasons ? "Hide Retail Linking Conflicts" : "Show Retail Linking Conflicts"} </button>
                        {showReasons &&
                            <section>
                                <h4>The following list is the reason(s) why there is no link associated with the retail HLA results:</h4>
                                <div dangerouslySetInnerHTML={{ __html: props.NoLinkReason }} />
                            </section>
                        }
                        </>
                    }
                </div>
            }
        </div>
    );
};

export default HighLowAverageView;
global.HighLowAverageView = HighLowAverageView;